// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-markdown.survey-markdown-basic {
    white-space: pre-wrap;
}

.survey-markdown-gfm img {
    max-width: 100%;
}

.survey-markdown-gfm>img {
    margin-bottom: 8px;
    margin-top: 8px;
}

.survey-markdown-gfm hr {
    margin-top: 16px;
    margin-bottom: 16px;
    border-color: var(--survey-border-color);
    color: var(--survey-border-color);
    background-color: var(--survey-border-color);
    border: 0;
    height: 1px;
}

.survey-markdown-gfm h1,
.survey-markdown-gfm h2,
.survey-markdown-gfm h3,
.survey-markdown-gfm h4,
.survey-markdown-gfm h5,
.survey-markdown-gfm h6,
.survey-markdown-gfm p {
    line-height: 1.3;
    margin: 0;
    padding: 0;
    margin-bottom: 16px;
    color: inherit;
    font-weight: normal;
}

.survey-markdown-gfm>*:last-child {
    margin-bottom: 0;
}


.survey-markdown-gfm em {
    font-style: italic;
    font-weight: inherit;
}

.survey-markdown-gfm strong {
    font-style: inherit;
    font-weight: bold;
}

.survey-markdown-gfm code {
    white-space: pre-wrap;
}

.survey-markdown-gfm h1 {
    font-size: 2em;
}

.survey-markdown-gfm h2 {
    font-size: 1.5em;
}

.survey-markdown-gfm h3 {
    font-size: 1.17em;
}

.survey-markdown-gfm h4 {
    font-size: 1em;
}

.survey-markdown-gfm h5 {
    font-size: 0.83em;
}

.survey-markdown-gfm h6 {
    font-size: 0.67em;
}

.survey-markdown-gfm table {
    width: 100%;
    border-collapse: collapse;
    margin: 16px 0;
}

.survey-markdown-gfm th {
    background-color: rgba(242, 243, 245, 1);
    font-weight: 600;
    text-align: left;
    padding: 4px 8px;
    border: solid 1px var(--survey-border-color);
}

.survey-markdown-gfm td {
    padding: 4px 8px;
    border: solid 1px var(--survey-border-color);
    vertical-align: top;
}

.survey-markdown-gfm table {
    overflow-x: auto;
}

.survey-markdown-gfm ul,
.survey-markdown-gfm ol {
    margin: 1em 0;
    padding-left: 2em;
}

.survey-markdown-gfm ul {
    list-style-type: disc;
}

.survey-markdown-gfm ol,
.survey-step .step-markdown-gfm ol {
    list-style-type: decimal;
    list-style-position: outside;
}

.survey-markdown-gfm li {
    margin: 0.4em 0;
}

/* Nested lists */
.survey-markdown-gfm ul ul,
.survey-markdown-gfm ul ol,
.survey-markdown-gfm ol ul,
.survey-markdown-gfm ol ol {
    margin: 0.5em 0;
    padding-left: 1.5em;
}

.survey-markdown-gfm code {
    background: #f6f8fa;
}

.survey-markdown-gfm pre code {
    padding: 8px;
    border-radius: 3px;
    overflow-x: auto;
    white-space: pre-wrap;
    display: block;
    margin-bottom: 16px;
}

.survey-markdown-gfm blockquote {
    border-left: 4px solid var(--survey-border-color);
    padding-left: 16px;
    margin: 16px 0;
    color: #555;
}

.survey-markdown-gfm .feature-card {
    background: rgba(242, 242, 247, 1);
    padding: 16px;
    border-radius: 14px;
    margin-bottom: 16px;
}

.survey-markdown-gfm .feature-card .feature-card-header {
    display: flex;
    align-items: center;
    gap: 16px;
    font-weight: 600;
}

.survey-markdown-gfm .feature-card .feature-card-header img {
    width: 30px;
}

.survey-markdown-gfm .feature-card p {
    margin-top: 16px;
    margin-bottom: 0;
    font-size: .88em;
}`, "",{"version":3,"sources":["webpack://./src/components/Survey/Components/SurveyMarkdown/SurveyMarkdown.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;IACxC,iCAAiC;IACjC,4CAA4C;IAC5C,SAAS;IACT,WAAW;AACf;;AAEA;;;;;;;IAOI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;AACjB;;;;IAII,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iDAAiD;IACjD,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".survey-markdown.survey-markdown-basic {\n    white-space: pre-wrap;\n}\n\n.survey-markdown-gfm img {\n    max-width: 100%;\n}\n\n.survey-markdown-gfm>img {\n    margin-bottom: 8px;\n    margin-top: 8px;\n}\n\n.survey-markdown-gfm hr {\n    margin-top: 16px;\n    margin-bottom: 16px;\n    border-color: var(--survey-border-color);\n    color: var(--survey-border-color);\n    background-color: var(--survey-border-color);\n    border: 0;\n    height: 1px;\n}\n\n.survey-markdown-gfm h1,\n.survey-markdown-gfm h2,\n.survey-markdown-gfm h3,\n.survey-markdown-gfm h4,\n.survey-markdown-gfm h5,\n.survey-markdown-gfm h6,\n.survey-markdown-gfm p {\n    line-height: 1.3;\n    margin: 0;\n    padding: 0;\n    margin-bottom: 16px;\n    color: inherit;\n    font-weight: normal;\n}\n\n.survey-markdown-gfm>*:last-child {\n    margin-bottom: 0;\n}\n\n\n.survey-markdown-gfm em {\n    font-style: italic;\n    font-weight: inherit;\n}\n\n.survey-markdown-gfm strong {\n    font-style: inherit;\n    font-weight: bold;\n}\n\n.survey-markdown-gfm code {\n    white-space: pre-wrap;\n}\n\n.survey-markdown-gfm h1 {\n    font-size: 2em;\n}\n\n.survey-markdown-gfm h2 {\n    font-size: 1.5em;\n}\n\n.survey-markdown-gfm h3 {\n    font-size: 1.17em;\n}\n\n.survey-markdown-gfm h4 {\n    font-size: 1em;\n}\n\n.survey-markdown-gfm h5 {\n    font-size: 0.83em;\n}\n\n.survey-markdown-gfm h6 {\n    font-size: 0.67em;\n}\n\n.survey-markdown-gfm table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 16px 0;\n}\n\n.survey-markdown-gfm th {\n    background-color: rgba(242, 243, 245, 1);\n    font-weight: 600;\n    text-align: left;\n    padding: 4px 8px;\n    border: solid 1px var(--survey-border-color);\n}\n\n.survey-markdown-gfm td {\n    padding: 4px 8px;\n    border: solid 1px var(--survey-border-color);\n    vertical-align: top;\n}\n\n.survey-markdown-gfm table {\n    overflow-x: auto;\n}\n\n.survey-markdown-gfm ul,\n.survey-markdown-gfm ol {\n    margin: 1em 0;\n    padding-left: 2em;\n}\n\n.survey-markdown-gfm ul {\n    list-style-type: disc;\n}\n\n.survey-markdown-gfm ol,\n.survey-step .step-markdown-gfm ol {\n    list-style-type: decimal;\n    list-style-position: outside;\n}\n\n.survey-markdown-gfm li {\n    margin: 0.4em 0;\n}\n\n/* Nested lists */\n.survey-markdown-gfm ul ul,\n.survey-markdown-gfm ul ol,\n.survey-markdown-gfm ol ul,\n.survey-markdown-gfm ol ol {\n    margin: 0.5em 0;\n    padding-left: 1.5em;\n}\n\n.survey-markdown-gfm code {\n    background: #f6f8fa;\n}\n\n.survey-markdown-gfm pre code {\n    padding: 8px;\n    border-radius: 3px;\n    overflow-x: auto;\n    white-space: pre-wrap;\n    display: block;\n    margin-bottom: 16px;\n}\n\n.survey-markdown-gfm blockquote {\n    border-left: 4px solid var(--survey-border-color);\n    padding-left: 16px;\n    margin: 16px 0;\n    color: #555;\n}\n\n.survey-markdown-gfm .feature-card {\n    background: rgba(242, 242, 247, 1);\n    padding: 16px;\n    border-radius: 14px;\n    margin-bottom: 16px;\n}\n\n.survey-markdown-gfm .feature-card .feature-card-header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    font-weight: 600;\n}\n\n.survey-markdown-gfm .feature-card .feature-card-header img {\n    width: 30px;\n}\n\n.survey-markdown-gfm .feature-card p {\n    margin-top: 16px;\n    margin-bottom: 0;\n    font-size: .88em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
